
export const ServerSetting = (state = '', action) => {
  switch (action.type) {

case 'SERVER_INFO':
		return action.server
    default:
      return state
  }
}